import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { SentenceSetContextProvider } from '@/contexts/SentenceSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { useLayoutEffect } from 'react';

export default function SentenceSet(
  props: StackScreenProps<TherapistStackParamList, 'SentenceSet'>,
) {
  useLayoutEffect(() => {
    if (props.route.params.templateMode === 'create') {
      props.navigation.setOptions({
        title: 'Set als Vorlage speichern',
        headerTitleAllowFontScaling: false,
      });
    } else if (props.route.params.templateMode === 'update')
      props.navigation.setOptions({
        title: 'Vorlage bearbeiten',
        headerTitleAllowFontScaling: false,
      });
  }, [props.navigation]);

  return (
    <SentenceSetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
      fromTemplate={props.route?.params?.fromTemplate}
    >
      <SetsSelectedWrapper props={props} />
    </SentenceSetContextProvider>
  );
}
